import { Link } from "react-router-dom";

interface VideoCardProps {
  slug: string;
  title: string;
  categoryName: string;
  description: string;
  coverImage: string;
  rating: number;
  views: string;
  updateStatus: string;
  episodeCount: string;
}

export default function VideoCard({
  slug,
  title,
  categoryName,
  description,
  coverImage,
  rating,
  views,
  updateStatus,
  episodeCount,
}: VideoCardProps) {
  return (
    <Link
      to={`/video/${slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          title={`${title} - 神马视频高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">
            {rating}
          </span>
        </div>
        <div className="absolute bottom-2 right-2">
          <span className="inline-block px-2 py-0.5 bg-black/60 text-white text-xs rounded">
            {episodeCount}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {description}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
          <span className="whitespace-nowrap">{categoryName}</span>
          <span className="whitespace-nowrap">{views}次播放</span>
        </div>
        <div className="mt-2">
          <span className={`inline-block px-2 py-0.5 text-xs rounded whitespace-nowrap ${
            updateStatus === "已完结" || updateStatus.includes("HD")
              ? "bg-green-100 text-green-700"
              : "bg-accent-100 text-accent-700"
          }`}>
            {updateStatus}
          </span>
        </div>
      </div>
    </Link>
  );
}